import { FETCH_DAIRIES_FAILURE, FETCH_DAIRIES_REQUEST, FETCH_DAIRIES_SUCCESS } from '../actions/actionTypes';

export default function DairiesReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_DAIRIES_REQUEST:
      return state;
    case FETCH_DAIRIES_SUCCESS:
      return action.payload;
    case FETCH_DAIRIES_FAILURE:
      return { error: action.payload };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/DairiesReducer.js